export const KEYS = {
  DEFAULT: {
    ACCESS_DENIED: "Zugriff verweigert",
    MISSING_MANDATORY_PERMISSION: "Sie haben nicht das notwendige Recht: <b>[[action]]</b> um auf <b>[[currentUri]]</b> zuzugreifen."
  }
};
